import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isAzureAdConfigured, loginRequest } from '../auth/msalConfig';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { VersionFooter } from '../components/common/VersionFooter';

// With ProtectedRoute auto-redirecting, users typically never see this page.
// It exists as a safety net: if a user lands here directly, kick off sign-in
// (or send them to the dashboard if they're already signed in).
export const LoginPage: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAzureAdConfigured || isAuthenticated || inProgress !== 'none') {
      return;
    }
    void instance.loginRedirect(loginRequest);
  }, [instance, isAuthenticated, inProgress]);

  if (!isAzureAdConfigured || isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Version footer here specifically for login/MSAL-config troubleshooting (OQ-2) —
  // readable before/during auth, unlike the rest of the app's authenticated pages.
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <LoadingSpinner message="Signing in..." />
      <VersionFooter />
    </div>
  );
};
